export default __webpack_public_path__ + "static/media/Linkedin icon.ed70d7e1.svg";